export const Sizes: Record<string, [w: number, h: number]> = {
  default: [3, 3],
  large: [4, 4],
};
